import React, { useState }  from 'react';
import { useNavigate } from "react-router-dom";

export const EditRecipePageTable = ({ recipeToEdit }) => {
 
    const [title, setTitle]       = useState(recipeToEdit.title);
    const [serves, setServes]         = useState(recipeToEdit.serves);
    const [date, setDate] = useState(recipeToEdit.date);
    
    const redirect = useNavigate();

    const editRecipe = async () => {
        const response = await fetch(`/recipes/${recipeToEdit._id}`, {
            method: 'PUT',
            body: JSON.stringify({ 
                title: title, 
                serves: serves, 
                date: date
            }),
            headers: {'Content-Type': 'application/json',},
        });

        if (response.status === 200) {
            alert(`${title} was updated!`);
        } else {
            const errMessage = await response.json();
            alert(`Those changes couldn't be saved; error code ${response.status}. ${errMessage.Error}`);
        }
        redirect("/RecipesPage");
    }

    return (
        <>
        <article>
            <h2>Edit a recipe</h2>
            <p>Paragraph about this page.</p>
            <table id="recipes">
                <caption>Which recipe are you adding?</caption>
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Serves</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                <td><label for="title">Recipe title</label>
                        <input
                            type="text"
                            placeholder="Recipe title"
                            value={title}
                            onChange={e => setTitle(e.target.value)} 
                            id="title" />
                    </td>

                    <td><label for="serves">Servings made</label>
                        <input
                            type="number"
                            value={serves}
                            placeholder="Servings made"
                            onChange={e => setServes(e.target.value)} 
                            id="serves" />
                    </td>

                    <td><label for="date">Date</label>
                        <input
                            type="date"
                            placeholder="Date created"
                            value={date}
                            onChange={e => setDate(e.target.value)} 
                            id="date" />
                    </td>

                    <td>
                    <label for="submit">Commit</label>
                        <button
                            type="submit"
                            onClick={editRecipe}
                            id="submit"
                        >Edit</button>
                    </td>
                </tr>
                </tbody>
            </table>
            </article>
        </>
    );
}
export default EditRecipePageTable;